<div class="p-6 max-w-md">
    <div class="flex items-start gap-3 mb-5">
        <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center shrink-0">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5 text-blue-600">confirmation_number</mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">{{ 'quickEasypass.dialogTitle' | translate }}</h2>
            <p class="text-sm text-slate-500 mt-0.5">{{ data.parkingSpace.name }}</p>
        </div>
    </div>

    @if (result(); as issued) {
    <div class="p-4 rounded-xl bg-green-50 border border-green-200 mb-4">
        <div class="text-lg font-semibold text-green-900 tracking-wide">{{ issued.easypass?.redemptions?.[0]?.licensePlate }}</div>
        <div class="text-sm text-green-800 mt-1">{{ 'quickEasypass.validUntil' | translate: { time: validUntil() } }}</div>
    </div>

    @if (issued.plateInside === false) {
    <div class="flex gap-2 p-3 rounded-lg bg-amber-50 border border-amber-200 text-amber-900 text-sm mb-4">
        <mat-icon class="!w-4 !h-4 !text-[16px] leading-4 shrink-0 mt-0.5">warning</mat-icon>
        <span>{{ 'quickEasypass.notInside' | translate }}</span>
    </div>
    }

    <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onClose()">{{ 'quickEasypass.close' | translate }}</jjames-button>
        <jjames-button variant="primary" (clicked)="onAnother()">{{ 'quickEasypass.another' | translate }}</jjames-button>
    </div>
    } @else {
    <label class="text-sm font-medium text-slate-900" for="qe-plate">{{ 'quickEasypass.licensePlate' | translate }}</label>
    <input id="qe-plate" type="text" autocomplete="off" autofocus spellcheck="false" [maxlength]="maxPlateLength"
           class="mt-2 w-full rounded-lg border border-slate-300 px-3 py-2 text-base uppercase tracking-wide focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
           [ngModel]="licensePlate()" (ngModelChange)="licensePlate.set($event)"
           (input)="onLicensePlateInput($event)" (keydown.enter)="onIssue()" />

    @if (errorMessage(); as message) {
    <div class="text-sm text-red-600 mt-3">{{ message }}</div>
    }

    <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onClose()">{{ 'common.cancel' | translate }}</jjames-button>
        <jjames-button variant="primary" [disabled]="!canIssue()" [loading]="isSaving()" (clicked)="onIssue()">
            {{ 'quickEasypass.issue' | translate }}
        </jjames-button>
    </div>
    }
</div>
